var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createClient, createConfig } from "@hey-api/client-fetch";
import { sanitizeBaseUrl } from "../../../utils";
import { isEligibleForTrial } from "../../evo-client/__generated__";
export class TssApiEvo {
    constructor(baseUrl, tenantToken, ciamToken) {
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.client = createClient(createConfig({ baseUrl: sanitizeBaseUrl(baseUrl), throwOnError: true }));
    }
    getEligibility(_a) {
        return __awaiter(this, arguments, void 0, function* ({ categoryId, userId }) {
            try {
                const { data } = yield isEligibleForTrial({
                    client: this.client,
                    headers: {
                        "X-DES-USER-TOKEN": this.ciamToken,
                        "X-DES-TENANT": this.tenantToken,
                    },
                    path: {
                        consumer: userId,
                        program: categoryId,
                    },
                });
                return Boolean(data === null || data === void 0 ? void 0 : data.is_eligible);
            }
            catch (e) {
                return false;
            }
        });
    }
}
//# sourceMappingURL=TssApiEvo.js.map